//should be moved into graphql appleApp.parameters.clientId
export const APPLE_CLIENT_ID = 'com.1stdibs.1stdibs.client';

export const ERROR_MESSAGES = {
    PINTEREST_APP_NOT_AVAILABLE: 'pinterest app is not available',
    FACEBOOK_APP_NOT_AVAILABLE: 'facebook app is not available',
    GOOGLE_APP_NOT_AVAILABLE: 'google app is not available',
    APPLE_APP_NOT_AVAILABLE: 'apple app is not available',
    MISSING_SOCIAL_NETWORK_PARAMETERS: 'missing social network parameters',
    THIRD_PARTY_COOKIES_DISABLED: 'Third party cookies are disabled',
};
